import escapeRegExp from './escapeRegExp';
import localization from 'locales/cz';

type Options = { [index: string]: string | number | undefined | null };
type Cache = { [index: string]: string | number };

const memo: Cache = {};

/**
 * @deprecated use i18next instead
 */
export function translate(
  key: string,
  options?: Options | null | undefined,
  messages = localization,
): string {
  if (memo[key]) {
    return String(memo[key]);
  }

  let optionsKey = '';

  if (options) {
    optionsKey = `${key}${JSON.stringify(options)}`;

    if (memo[optionsKey]) {
      return String(memo[optionsKey]);
    }
  }

  const path: string = key.replace(/\[(\w+)\]/g, '.$1');
  const sanitizedPath: string = path.replace(/^\./, '');
  // TODO: Probably just completely ditch the translate function

  const arr: any[] = sanitizedPath.split('.');

  try {
    const message = arr.reduce(
      (accumulator, currentValue) => accumulator[currentValue],
      messages,
    );

    if (message) {
      if (options) {
        const objectKeys = Object.keys(options);
        const messageWithOptions = objectKeys.reduce(
          (accumulator, currentValue) => {
            const optionValue = options[currentValue] || '';
            const prefix =
              typeof optionValue === 'number' ? `=${optionValue}` : optionValue;
            const PHRAZE_REGEXP = new RegExp(
              `${escapeRegExp(prefix)} \\[([^[\\]]+(?=]))\\]`,
            );

            const PHRAZE_FALLBACK_REGEXP = /other \[([^[\]]+(?=]))\]/;
            let phraze = '';
            const SANITIZE_REGEXP = new RegExp(`{${currentValue}}`, 'g');
            const sanitizedMessage = accumulator.replace(
              SANITIZE_REGEXP,
              optionValue,
            );

            if (sanitizedMessage.match(PHRAZE_REGEXP)) {
              [, phraze] = sanitizedMessage.match(PHRAZE_REGEXP);
            } else if (sanitizedMessage.match(PHRAZE_FALLBACK_REGEXP)) {
              [, phraze] = sanitizedMessage.match(PHRAZE_FALLBACK_REGEXP);
            }

            const phrazeWithNumber = phraze.replace(
              /#/,
              String(options[currentValue]),
            );
            const PLURALIZED_MESSAGE_REGEXP = new RegExp(
              `{${currentValue}, plural, .*?}`,
            );
            const pluralizedMessage = sanitizedMessage.replace(
              PLURALIZED_MESSAGE_REGEXP,
              phrazeWithNumber,
            );

            return pluralizedMessage;
          },
          message,
        );

        memo[optionsKey] = messageWithOptions;

        return messageWithOptions;
      }

      memo[key] = message;

      return message;
    }

    memo[key] = `{${sanitizedPath}}`;

    return `{${sanitizedPath}}`;
  } catch (exception) {
    memo[key] = `{${sanitizedPath}}`;

    console.error(exception);

    return `{${sanitizedPath}}`;
  }
}

export function getCzechTimeTranslationKey(
  amount: number,
  prefix?: string,
): string {
  let subkey = '';
  if (amount === 1) {
    subkey = 'one';
  } else if (amount >= 2 && amount <= 4) {
    subkey = 'few';
  } else {
    // This also includes 0
    subkey = 'many';
  }

  return `${prefix ? `${prefix}.` : ''}${subkey}`;
}

export function parseLineBreaks(input: string): React.ReactNode {
  return input
    .split('\n')
    .flatMap((el, index) => [<br key={index} />, el])
    .slice(1);
}

export default translate;
